<template>
    <div v-if="store.state.isModalOpenTwo" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-lg modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">Sign In/Up</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="p-2">
                  <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item active">
                      <a class="nav-link active" id="sign-up-tab-fill" data-bs-toggle="tab" href="#sign-up-tab" role="tab" aria-controls="sign-up-tab" aria-selected="false">Sign Up</a>
                    </li>
                    <li v-if="isVerifyOtpTab" class="nav-item">
                      <a class="nav-link" id="sign-up-tab-fill" data-bs-toggle="tab" href="#verify-otp-tab" role="tab" aria-controls="verify-otp-tab" aria-selected="false">Verify Otp</a>
                    </li>
                    <li class="nav-item active">
                      <a class="nav-link" id="sign-in-fill" data-bs-toggle="tab" href="#sign-in-tab" role="tab" aria-controls="sign-in-tab" aria-selected="false">Sign In</a>
                    </li>
                  </ul>
                  <hr>
                  <div class="tab-content">
                    <div class="tab-pane show active" id="sign-up-tab" role="tabpanel" aria-labelledby="sign-up-tab-fill">
                      <div class="row">
                        <form class="auth-register-form mt-2" @submit.prevent="register()">
                          <div class="mb-1">
                            <label class="form-label" for="register-username">Full Name</label>
                            <input class="form-control" id="register-username" v-model="formData.name" type="text"
                                   name="register-username" placeholder="Enter Your Name" aria-describedby="register-username"
                                   autofocus="" tabindex="1"/>
                          </div>
                          <div class="mb-1">
                            <label class="form-label" for="register-email">Email</label>
                            <input class="form-control" id="register-email" type="text" name="register-email"
                                   v-model="formData.email" placeholder="Email (as user id)" aria-describedby="register-email"
                                   tabindex="2"/>
                          </div>
                          <div class="mb-1">
                            <label class="form-label" for="register-phone">Phone</label>
                            <input class="form-control" id="register-phone" type="text" name="register-email"
                                   v-model="formData.phone" placeholder="Phone" aria-describedby="register-phone"
                                   tabindex="2"/>
                          </div>
                          <div class="mb-1">
                            <label class="form-label" for="register-password">Password</label>
                            <div class="input-group input-group-merge form-password-toggle" v-if="!showPassword">
                              <input class="form-control form-control-merge" id="register-password" v-model="formData.password"
                                     type="password" name="register-password" placeholder="············"
                                     aria-describedby="register-password" tabindex="3"/><span
                                class="input-group-text cursor-pointer" @click="toggleShow"><i class="fas fa-eye"></i></span>
                            </div>
                            <div class="input-group input-group-merge form-password-toggle" v-if="showPassword">
                              <input class="form-control form-control-merge" id="register-password" v-model="formData.password"
                                     type="text" name="register-password" placeholder="············"
                                     aria-describedby="register-password" tabindex="3"/><span
                                class="input-group-text cursor-pointer" @click="toggleShow"><i class="fas fa-eye-slash"></i></span>
                            </div>
                          </div>
                          <div class="mb-1">
                            <label class="form-label" for="register-password">Confirm Password</label>
                            <div class="input-group input-group-merge form-password-toggle" v-if="!showConfirmPassword">
                              <input class="form-control form-control-merge" id="register-password" type="password"
                                     v-model="confirmPass"
                                     name="register-password" placeholder="············" aria-describedby="register-password"
                                     tabindex="3"/><span class="input-group-text cursor-pointer"  @click="toggleConfirmShow"><i class="fas fa-eye"></i></span>
                            </div>
                            <div class="input-group input-group-merge form-password-toggle" v-if="showConfirmPassword">
                              <input class="form-control form-control-merge" id="register-password" type="text"
                                     v-model="confirmPass"
                                     name="register-password" placeholder="············" aria-describedby="register-password"
                                     tabindex="3"/><span class="input-group-text cursor-pointer" @click="toggleConfirmShow"><i class="fas fa-eye-slash"></i></span>
                            </div>
                          </div>

                          <div class="mb-1">
                            <div class="form-check">
                              <input :disabled="formData.name && formData.email && formData.password && !confirmPass" class="form-check-input" id="register-privacy-policy" type="checkbox" tabindex="4" @click="enableRegistration()"/>
                              <label class="form-check-label" for="register-privacy-policy">I agree to<a href="#">&nbsp;privacy
                                policy & terms</a></label>
                            </div>
                          </div>
                          <div v-if="acceptedPrivacyPolicy">
                            <button v-if="!loading" class="btn btn-primary w-100" tabindex="5">Sign up</button>
                            <button v-else disabled class="btn btn-primary w-100" tabindex="5">
                              <span class="spinner-border spinner-border-sm text-white" role="status" aria-hidden="true"></span>
                              Sign up
                            </button>
                          </div>
                          <div v-else>
                            <button v-if="!loading" disabled class="btn btn-primary w-100" tabindex="5">Sign up</button>
                          </div>
                        </form>
                      </div>
                    </div>

                    <div class="tab-pane" id="verify-otp-tab" role="tabpanel" aria-labelledby="verify-otp-tab-fill">
                      <form @submit.prevent="submitOtp">
                        <div class="mb-2">
                          <label>Phone</label>
                          <input disabled type="text" class="form-control" :value="otpFormData.phone" placeholder="Enter your phone number">
                        </div>
                        <div class="mb-2">
                          <label>OTP</label>
                          <input type="text" class="form-control" v-model="otpFormData.otp_number" maxlength="6" placeholder="Enter the OTP">
                        </div>

                        <div>
                          <button class="btn btn-primary w-100" :disabled="loading">
                            <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                            Verify
                          </button>
                        </div>

                        <div class="text-center mt-2">
                          <button class="btn btn-link p-0" @click="resendOtp" :disabled="loading">
                            Resend OTP
                          </button>
                        </div>

                      </form>
                    </div>

                    <div class="tab-pane" id="sign-in-tab" role="tabpanel" aria-labelledby="sign-in-tab-fill">
                      <form class="auth-login-form mt-2" method="POST" @submit.prevent="login()">
                        <div class="mb-1">
                          <label class="form-label" for="login-email">Email/Phone</label>
                          <input class="form-control" id="login-email" v-model="loginFormData.email" type="text" name="login-email"
                                 placeholder="Email" aria-describedby="login-email" autofocus="" tabindex="1"/>
                        </div>
                        <div class="mb-1">
                          <div class="d-flex justify-content-between">
                            <label class="form-label" for="login-password">Password</label><router-link to="reset-password"><small>Forgot Password?</small></router-link>
                          </div>
                          <div class="input-group input-group-merge form-password-toggle" v-if="!showPassword">
                            <input class="form-control form-control-merge" id="login-password" type="password"
                                   v-model="loginFormData.password" name="login-password" placeholder="············"
                                   aria-describedby="login-password" tabindex="2"/><span
                              class="input-group-text cursor-pointer"  @click="toggleShow"><i class="fas fa-eye"></i></span>
                          </div>
                          <div class="input-group input-group-merge form-password-toggle" v-if="showPassword">
                            <input class="form-control form-control-merge" id="login-password" type="text"
                                   v-model="loginFormData.password" name="login-password" placeholder="············"
                                   aria-describedby="login-password" tabindex="2"/><span
                              class="input-group-text cursor-pointer"  @click="toggleShow"><i class="fas fa-eye-slash"></i></span>
                          </div>
                        </div>
                        <div class="mb-1">
                          <div class="form-check">
                            <input class="form-check-input" id="remember-me" type="checkbox" tabindex="3"/>
                            <label class="form-check-label" for="remember-me"> Remember Me</label>
                          </div>
                        </div>
                        <button v-if="!loading" class="btn btn-primary w-100" tabindex="4">Sign in</button>
                        <button v-else disabled class="btn btn-primary w-100" tabindex="4">
                          <span class="spinner-border spinner-border-sm text-white" role="status" aria-hidden="true"></span>
                          Sign in
                        </button>
                      </form>

                    </div>

                  </div>

                 </div>
            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import {inject, nextTick, ref} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import fetchUser from '@/services/modules/login'
import handleRegistration from '@/services/modules/register'

const emit = defineEmits(['submitted']);
const store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const loader = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const confirmPass = ref(null);
const showPassword = ref(false);
const showConfirmPassword = ref(false)
const isVerifyOtpTab = ref(false)
const acceptedPrivacyPolicy = ref(false)

const formData = ref({
  name: null,
  email: null,
  password: null,
  phone: null,
})

const loginFormData = ref({
  email: null,
  password: null,
})

const otpFormData = ref({
  phone: null,
  otp_number: null,
})

const {
  registerJobApplicantUser,
  otpVerifyUser,
  resendOtpUser
} = handleRegistration();

const {
  loginUser,
  setUserInLocalStorage,
  setTokenInLocalStorage,
  setPublicTokenInLocalStorage
} = fetchUser();

const register = async() => {
  let registerData = {}
  loading.value = true;
  registerData.name = formData.value.name
  registerData.email = formData.value.email
  registerData.password = formData.value.password
  registerData.phone = formData.value.phone
  registerData.password_confirmation = confirmPass.value

  registerJobApplicantUser(registerData)
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
        showSuccess(res.message)
        isVerifyOtpTab.value = true;
        otpFormData.value.phone  = res.data.phone
        nextTick(() => {
          const otpTab = document.querySelector('[href="#verify-otp-tab"]')
          if (otpTab && window.bootstrap) {
            const tab = new window.bootstrap.Tab(otpTab)
            tab.show()
          }
        })
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
         loading.value = false
        loader.value = false
  })
}

const login = async() => {
  let registerData = {}
  loading.value = true;
  registerData.email = loginFormData.value.email
  registerData.password = loginFormData.value.password

  await loginUser(registerData)
      .then(res => {
        if (!res.status) {
          showError(res.message)
        }
        if(!res.status && res.otp_verification) {
          isVerifyOtpTab.value = true;
          otpFormData.value.phone  = res.data.phone
          nextTick(() => {
            const otpTab = document.querySelector('[href="#verify-otp-tab"]')
            if (otpTab && window.bootstrap) {
              const tab = new window.bootstrap.Tab(otpTab)
              tab.show()
            }
          })
        }
        if(res.status) {
          setUserInLocalStorage(res.data)
          setTokenInLocalStorage(res.access_token)
          setPublicTokenInLocalStorage(res.public_access_token);
          store.commit('user/setUser')
          onClickClose()
        }
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
    loading.value = false
    loader.value = false
  })
}

const submitOtp = async() => {
  let otpData = {}
  loading.value = true;
  otpData.phone = otpFormData.value.phone
  otpData.otp_number = otpFormData.value.otp_number

  otpVerifyUser(otpData)
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
        showSuccess(res.message)
        isVerifyOtpTab.value = false;
        nextTick(() => {
          const otpTab = document.querySelector('[href="#sign-in-tab"]')
          if (otpTab && window.bootstrap) {
            const tab = new window.bootstrap.Tab(otpTab)
            tab.show()
          }
        })
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loading.value = false
        loader.value = false

  })
}

const resendOtp = async() => {
  let otpData = {}
  loading.value = true;
  otpData.phone = otpFormData.value.phone

  resendOtpUser(otpData)
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
        showSuccess(res.message)
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loading.value = false
        loader.value = false
      })
}

const toggleShow = () => {
  showPassword.value = !showPassword.value;
}

const toggleConfirmShow = () => {
   showConfirmPassword.value = !showConfirmPassword.value;
}

const enableRegistration = () => {
  acceptedPrivacyPolicy.value = acceptedPrivacyPolicy.value !== true;
}

const onClickClose = () => {
  store.state.isModalOpenTwo = false;
}

</script>
